import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'traceability-matrix',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'traceability-matrix.covered',
                        },
                      },
                    },
                    span: 2,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'traceability-matrix.partial',
                        },
                      },
                    },
                    span: 2,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'traceability-matrix.orphaned',
                        },
                      },
                    },
                    span: 2,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'traceability-matrix.awaiting-approval',
                        },
                      },
                    },
                    span: 2,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'traceability-matrix.unverified',
                        },
                      },
                    },
                    span: 2,
                  },
                ],
              },
            },
            height: 140,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'traceability-matrix.table',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
        ],
      },
    },
    description:
      'See how every requirement traces to its pull requests, tests, review, and docs',
    name: 'Traceability Matrix',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
